import { useContext, useEffect } from "react";
import { useState } from "react";
import LocationContext from "@/common/Contexts/LocationContext";
import { SECURE_COOKIE } from "@globalConfig";
import useCookieClient from "@hooks/useCookieClient";
import { checkTestFlag } from "@/common/config/websiteConfig";
var COOKIE_NANE = "support_googlepay";
function getLocationParams(search) {
  return new URLSearchParams(search);
}
export default function useSupportGooglePay() {
  if (__IS_SSR__) {
    var locationContext = useContext(LocationContext);
    var _params = getLocationParams(locationContext.search || "");
    return _params.get("support_googlepay") === "true";
  }
  var params = getLocationParams(location.search);
  var _useState = useState(params.get("support_googlepay") === "true"),
    supportGooglePay = _useState[0],
    setSupportGooglePay = _useState[1];
  var _useCookieClient = useCookieClient(),
    getCookieClient = _useCookieClient.getCookieClient,
    setCookieClient = _useCookieClient.setCookieClient;
  useEffect(function () {
    if (checkTestFlag("TEST_SUPPORT_GOOGLE_PAY") !== undefined) {
      return setSupportGooglePay(checkTestFlag("TEST_SUPPORT_GOOGLE_PAY"));
    }
    if (supportGooglePay) {
      setCookieClient(COOKIE_NANE, "1", {
        path: "/",
        maxAge: 3600 * 24 * 365 * 10,
        // Cookie will expire after 10 years
        sameSite: true,
        secure: SECURE_COOKIE
      });
    } else if (getCookieClient(COOKIE_NANE) === "1") {
      setSupportGooglePay(true);
    }
  }, [supportGooglePay]);
  return supportGooglePay;
}